<template>
    <div class="vue-calendar">
        <vue-cal hide-view-selector
                 :events="events"
                 :time="false"
                 default-view="month"
                 events-on-month-view="short"
                 @ready="fetchEvents"
                 @view-change="fetchEvents">
        </vue-cal>
    </div>
</template>

<script>
    import axios  from 'axios';
    import VueCal from 'vue-cal'
    import 'vue-cal/dist/vuecal.css';

    export default {

        name: 'calendar',

        components: {VueCal},

        data: () => ({
            events: [],
            loading: false,
        }),

        methods: {

            fetchEvents({view, startDate, endDate} = {view: 'month', startDate: null, endDate: null}) {

                if (view == null || startDate == null || endDate == null) {
                    let date  = new Date(),
                        year  = date.getFullYear(),
                        month = date.getMonth();

                    startDate = new Date(year, month);
                    endDate   = new Date(year, month + 1, 0);
                }

                this.events  = [];
				this.loading = true;
				
				axios.get('/ajax/events?start=' + startDate.toDateString() + '&end=' + endDate.toDateString())
				.then(response => {

                    this.events = response.data.map(item => {
                        return {
                            title: item.title,
                            content: '',
                            start: item.event_date_start,
                            end: item.event_date_end,
                            class: 'calendar-event',
                            editable: false,
                        };
                    });

                    this.loading = false;
                });
            },
        }
    }
</script>

<style scoped lang="scss">

</style>